import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { purpleMui } from "@ryde/theme";

const BULK_ACTION_STACK_GAP_PX = 8;
const BULK_ACTION_STACK_PADDING_INLINE_START_PX = 10;

export const BulkActionFieldStackStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-action-field-stack",
})`
  display: flex;
  flex-direction: column;
  gap: ${BULK_ACTION_STACK_GAP_PX}px;
  width: 100%;
  padding-inline-start: ${BULK_ACTION_STACK_PADDING_INLINE_START_PX}px;
  border-inline-start: 1px dashed ${purpleMui._700};
`;
